// @flow

import React, { PureComponent } from "react";
import { map, get, noop } from "lodash";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { bets } from "@fdr/static-ui/Icons/icons";
import type { Probable, RaceStatus } from "@tvg/types/Race";
import type { UnaryFn } from "@tvg/types/Functional";
import type { emptyMessageGtm, RaceBet } from "@fdr/types/MyBets";
import BetSummary from "../../_molecules/BetSummary";
import {
  BetList,
  BetListItem,
  EmptyMessageWrapper,
  EmptyMessageCard
} from "./styled-components";

import Info from "../../_molecules/Info";

type Props = {
  bets: ?Array<RaceBet>,
  raceNumber: string | number,
  hasPromosOptedIn: boolean,
  showRace: boolean,
  emptyMessage: {
    title: string,
    body: string,
    nextRaceGtm: emptyMessageGtm,
    allTracksGtm: emptyMessageGtm
  },
  /**
   * Empty message gtm events callback
   */
  emptyMessageCallback: UnaryFn<mixed, void>,
  showSimpleEmptyMessage: boolean,
  probables: Probable[],
  /**
   * Toogles potential return feature
   */
  showPotentialReturn: boolean,
  /**
   * Opens help modal potential return
   */
  openPotencialReturnModal: UnaryFn<boolean, void>,
  /**
   * Toggle to check if component is being called form Bet Resulted tab
   */
  isFromResultedBetTab?: boolean,
  remainingDayCancelledCount: number,
  status: RaceStatus
};

export default class RaceBets extends PureComponent<Props> {
  static defaultProps = {
    bets: [],
    raceNumber: "1",
    hasPromosOptedIn: false,
    showRace: true,
    showSimpleEmptyMessage: true,
    emptyMessage: {
      title: "",
      body: "",
      nextRaceGtm: {
        buttonText: "",
        module: "",
        destinationUrl: ""
      },
      allTracksGtm: {
        buttonText: "",
        module: "",
        destinationUrl: ""
      }
    },
    emptyMessageCallback: noop,
    probables: [],
    showPotentialReturn: false,
    openPotencialReturnModal: noop,
    isFromResultedBetTab: false,
    remainingDayCancelledCount: 0,
    status: { code: "O" }
  };

  render() {
    return get(this.props, "bets.length") > 0 ? (
      <BetList
        showRace={this.props.showRace}
        isFromResultedBetTab={this.props.isFromResultedBetTab}
      >
        <TransitionGroup component="ul" data-qa-label="betlist">
          {map(this.props.bets, (bet: RaceBet) => (
            <CSSTransition
              timeout={4000}
              key={`bet-${bet.id}`}
              classNames="bet-list-item"
            >
              <BetListItem
                isWinningBet={
                  bet.totalWinAmount && bet.totalWinAmount > bet.betTotal
                }
              >
                <BetSummary
                  className="betSummary"
                  borderTotalWidth={!this.props.showRace}
                  isCancelable={bet.isCancelable}
                  betTotal={bet.betTotal}
                  horseNamesList={bet.horseNamesList}
                  selectionType={bet.wagerType.name}
                  wagerType={bet.wagerType}
                  wagerAmount={bet.wagerAmount}
                  selections={bet.selections}
                  raceTypeCode={bet.raceTypeCode}
                  isKey={bet.isKey}
                  isLeg={bet.isLeg}
                  isVertical
                  onDelete={bet.onDelete}
                  isLost={bet.isLost}
                  isRepeatable={bet.isRepeatable}
                  isPromoQualifying={bet.isPromoQualifying}
                  hasRepeatButton={bet.hasRepeatButton}
                  hasRepeaterEnabled={bet.hasRepeaterEnabled}
                  onRepeatClick={bet.onRepeatClick}
                  repetitionsNr={bet.repetitionsNr}
                  isCancelled={bet.isCancelled}
                  isRefunded={bet.isRefunded}
                  totalWinAmount={bet.totalWinAmount}
                  raceNumber={this.props.raceNumber}
                  hasPromosOptedIn={this.props.hasPromosOptedIn}
                  isBorderBottom={!this.props.showRace}
                  probables={this.props.probables}
                  showPotentialReturn={this.props.showPotentialReturn}
                  openPotencialReturnModal={this.props.openPotencialReturnModal}
                  remainingDayCancelledCount={
                    this.props.remainingDayCancelledCount
                  }
                  status={this.props.status}
                />
              </BetListItem>
            </CSSTransition>
          ))}
        </TransitionGroup>
      </BetList>
    ) : (
      <EmptyMessageWrapper>
        <EmptyMessageCard>
          <Info
            title={this.props.emptyMessage.body}
            fullWidth
            upperIconType="bets"
            icon={bets}
            hasUpperIcon
          />
        </EmptyMessageCard>
      </EmptyMessageWrapper>
    );
  }
}
